window.LeMiniTransition = (function () {
  var PRODUCT_INFO_SELECTOR = 'product-info[id^="MainProduct"]';
  var abortController = null;

  function absolutePath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return url;
    }
  }

  function getProductInfoNode() {
    return document.querySelector(PRODUCT_INFO_SELECTOR);
  }

  function isElementVisible(el) {
    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom > 0 && rect.top < viewportHeight;
  }

  function scrollToPanelIfNeeded(panelNode) {
    if (!panelNode || isElementVisible(panelNode)) return;
    panelNode.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Recentre le carrousel (Bloc 1, jamais re-rendu) sur la slide dont le lien
  // correspond à l'URL cible, s'il existe sur la page.
  function syncCoverflow(url) {
    var coverflowRoot = document.querySelector('[data-hero-coverflow]');
    if (!coverflowRoot || typeof coverflowRoot.leMiniGoTo !== 'function') return;

    var targetPath = absolutePath(url);
    var items = coverflowRoot.querySelectorAll('[data-coverflow-item]');
    for (var i = 0; i < items.length; i++) {
      var link = items[i].querySelector('a[href]');
      if (link && absolutePath(link.getAttribute('href')) === targetPath) {
        coverflowRoot.leMiniGoTo(parseInt(items[i].getAttribute('data-index'), 10));
        return;
      }
    }
  }

  function swap(url, options) {
    options = options || {};
    var pushHistory = options.pushHistory !== false;
    var scrollIfNeeded = options.scrollIfNeeded === true;

    var oldNode = getProductInfoNode();
    if (!oldNode) {
      window.location.href = url;
      return;
    }

    syncCoverflow(url);

    if (abortController) abortController.abort();
    abortController = new AbortController();

    oldNode.classList.add('le-mini-loading');

    fetch(url, { signal: abortController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (responseText) {
        var doc = new DOMParser().parseFromString(responseText, 'text/html');
        var newProductInfo = doc.querySelector(PRODUCT_INFO_SELECTOR);
        if (!newProductInfo) throw new Error('product-info introuvable dans la reponse fetch');

        var newTitle = doc.querySelector('title');
        if (newTitle) document.title = newTitle.textContent;

        var newCanonical = doc.querySelector('link[rel="canonical"]');
        var currentCanonical = document.querySelector('link[rel="canonical"]');
        if (newCanonical && currentCanonical) currentCanonical.setAttribute('href', newCanonical.getAttribute('href'));

        if (pushHistory) {
          window.history.pushState({ leMiniProduct: true }, '', url);
        }

        HTMLUpdateUtility.viewTransition(oldNode, newProductInfo);

        if (scrollIfNeeded) scrollToPanelIfNeeded(getProductInfoNode());
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        console.error('[LeMiniTransition] fetch echoue, fallback navigation classique', error);
        window.location.href = url;
      });
  }

  function navigateTo(url, options) {
    swap(url, options);
  }

  // ── Point d'entrée Bloc 2 : vignettes color_switch, délégué car recréées à chaque swap ──
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.lmcs__item');
    if (!link) return;
    event.preventDefault();
    navigateTo(link.getAttribute('href'), { pushHistory: true, scrollIfNeeded: false });
  });

  // ── Retour / avant navigateur ──────────────────────────────────────────────
  window.addEventListener('popstate', function () {
    swap(window.location.pathname + window.location.search, { pushHistory: false, scrollIfNeeded: false });
  });

  return { navigateTo: navigateTo };
})();
